import { CommApiInstance } from "Utils/CommApiInstance";


const MembGameSvcItemPrsnLstInqApi = async (
    gameSvcCd:string,
    nowPageNo:number,
    srchStrtDt:string,
    srchEndDt:string
) => {
    return await CommApiInstance.post(`pymt/${gameSvcCd}/prsn_lst?page=${nowPageNo}`,{
        apiBody: {
            srchStrtDt: srchStrtDt,
            srchEndDt: srchEndDt
        }
    })
    .then((Resp) => Resp.data);
}

export default MembGameSvcItemPrsnLstInqApi;